/* Ruvio & Co. theme script: cart drawer (Shopify AJAX Cart API), variant picker, collection chips, gallery */
(function () {
  'use strict';
  var R = window.Ruvio || {};
  var routes = R.routes || {};
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    var fmt = R.moneyFormat || '${{amount}}';
    cents = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : cents;
    function delim(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return delim(cents, 2, ',', '.');
      }
    });
  }
  R.formatMoney = formatMoney;

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2600);
  }

  function api(url, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong');
        return j;
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('#CartDrawer');
  var shade = $('#CartShade');
  var lastFocus = null;

  function openCart() {
    if (!drawer) { window.location.href = routes.cart_url; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    shade.hidden = false; document.body.style.overflow = 'hidden';
    setTimeout(function () { var x = $('.x', drawer); if (x) x.focus(); }, reduceMotion ? 0 : 200);
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    shade.hidden = true; document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 120);
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (!drawer) return;
    var lines = $('#CartLines', drawer);
    if (!cart.items.length) {
      lines.innerHTML = '<div class="empty"><p>Your cart is empty.</p><a class="btn" href="' + esc(routes.all_products || '/collections/all') + '">Shop best sellers</a></div>';
    } else {
      lines.innerHTML = cart.items.map(function (it) {
        var opts = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
        var sell = it.selling_plan_allocation ? '<small>' + esc(it.selling_plan_allocation.selling_plan.name) + '</small>' : '';
        var disc = (it.line_level_discount_allocations || []).map(function (d) { return '<small>' + esc(d.discount_application.title) + ' (−' + formatMoney(d.amount) + ')</small>'; }).join('');
        var pic = it.image ? '<img src="' + esc(img(it.image, 140)) + '" alt="" width="60" height="60" loading="lazy">' : '<span class="ph"></span>';
        return '<div class="line" data-key="' + esc(it.key) + '">' + pic +
          '<div class="line__info"><a href="' + esc(it.url) + '" style="text-decoration:none"><b>' + esc(it.product_title) + '</b></a>' + opts + sell + disc +
          '<div class="line__row"><div class="qty"><button type="button" data-qty="-1" aria-label="Decrease quantity">−</button>' +
          '<input type="number" min="0" value="' + it.quantity + '" aria-label="Quantity" data-line-qty>' +
          '<button type="button" data-qty="1" aria-label="Increase quantity">+</button></div>' +
          '<span class="line__price">' + formatMoney(it.final_line_price) + '</span></div>' +
          '<button type="button" class="link-btn" data-remove>Remove</button></div></div>';
      }).join('');
    }
    var sub = cart.total_price;
    $('#CartSubtotal', drawer).textContent = formatMoney(sub);
    var free = $('#CartFree', drawer);
    var thr = R.freeShippingThreshold || 0;
    if (free) {
      if (thr > 0) {
        var left = Math.max(0, thr - sub);
        free.hidden = false;
        free.innerHTML = (left > 0 ? 'Add <b>' + formatMoney(left) + '</b> more for free shipping' : '<b>Free shipping unlocked</b>') +
          '<div class="bar"><i style="width:' + Math.min(100, (sub / thr) * 100) + '%"></i></div>';
      } else { free.hidden = true; }
    }
    var up = $('#CartUpsell', drawer);
    if (up && R.upsell && R.upsell.id) {
      var inCart = cart.items.some(function (i) { return String(i.variant_id) === String(R.upsell.id); });
      up.hidden = inCart || !cart.items.length;
    }
    var co = $('#CartCheckout', drawer);
    if (co) co.disabled = !cart.items.length;
  }

  function refreshCart() { return api(routes.cart_url + '.js').then(renderCart); }

  function addItems(items, btn) {
    if (btn) { btn.disabled = true; btn.dataset.label = btn.dataset.label || btn.textContent; }
    return api(routes.cart_add_url + '.js', { items: items })
      .then(function () { return refreshCart(); })
      .then(function () {
        if (btn) { btn.classList.add('is-done'); btn.textContent = 'Added'; setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = btn.dataset.label; btn.disabled = false; }, 1200); }
        if (R.openDrawerOnAdd !== false) openCart(); else toast('Added to cart');
      })
      .catch(function (e) { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } toast(e.message); });
  }

  function changeLine(key, qty) {
    var line = drawer && $('.line[data-key="' + CSS.escape(key) + '"]', drawer);
    if (line) line.classList.add('is-loading');
    return api(routes.cart_change_url + '.js', { id: key, quantity: qty })
      .then(renderCart)
      .catch(function (e) { toast(e.message); refreshCart(); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-open-cart]');
    if (opener && drawer) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-close-cart]')) { closeCart(); return; }

    var quick = t.closest('[data-add-variant]');
    if (quick) { e.preventDefault(); addItems([{ id: +quick.dataset.addVariant, quantity: 1 }], quick); return; }

    var multi = t.closest('[data-add-variants]');
    if (multi) {
      e.preventDefault();
      var ids = multi.dataset.addVariants.split(',').filter(Boolean).map(function (id) { return { id: +id, quantity: 1 }; });
      if (ids.length) addItems(ids, multi);
      return;
    }

    var q = t.closest('[data-qty]');
    if (q) {
      var wrap = q.closest('.qty'); var input = $('input', wrap);
      var v = Math.max(0, (parseInt(input.value, 10) || 0) + (+q.dataset.qty));
      if (input.hasAttribute('data-line-qty')) { changeLine(q.closest('.line').dataset.key, v); }
      else { input.value = Math.max(1, v); }
      return;
    }
    var rm = t.closest('[data-remove]');
    if (rm && rm.closest('.line')) { changeLine(rm.closest('.line').dataset.key, 0); return; }

    var chip = t.closest('[data-filter]');
    if (chip) {
      var group = chip.closest('[data-filter-group]');
      var val = chip.dataset.filter;
      $$('[data-filter]', group).forEach(function (b) { b.setAttribute('aria-pressed', String(b === chip)); });
      var grid = $('#' + group.dataset.filterGroup);
      var shown = 0;
      $$('.card', grid).forEach(function (c) {
        var ok = val === 'all' || (' ' + c.dataset.collections + ' ').indexOf(' ' + val + ' ') > -1;
        c.hidden = !ok; if (ok) shown++;
      });
      var counter = $('[data-filter-count]', group.parentNode);
      if (counter) counter.textContent = shown + ' products';
      return;
    }

    var th = t.closest('[data-thumb]');
    if (th) {
      var main = $('[data-gallery-main]');
      if (main) {
        main.innerHTML = '<img src="' + esc(th.dataset.thumb) + '" alt="' + esc(th.dataset.alt || '') + '" width="1000" height="1000">';
        $$('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', String(b === th)); });
      }
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches('[data-line-qty]')) changeLine(input.closest('.line').dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
    if (input.matches('[data-sort]')) {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', input.value); u.searchParams.delete('page');
      window.location.href = u.toString();
    }
    if (input.closest('[data-filter-form]')) input.closest('form').submit();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCart();
    if (e.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
      var f = $$('a[href],button:not([disabled]),input,select', drawer).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* AJAX add-to-cart for product forms */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('.js-ajax-cart') || !drawer) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qtyEl = form.querySelector('[name="quantity"]');
    var item = { id: +id, quantity: qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1 };
    var sp = form.querySelector('[name="selling_plan"]');
    if (sp && sp.value) item.selling_plan = +sp.value;
    addItems([item], form.querySelector('[type="submit"]'));
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product-json]').forEach(function (node) {
    var product; try { product = JSON.parse(node.textContent); } catch (err) { return; }
    var root = node.closest('[data-product]');
    if (!root) return;
    function selected() { return $$('.option-group', root).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
    function update() {
      var opts = selected();
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      var btn = $('[data-add-button]', root);
      var idInput = $('[name="id"]', root);
      var priceEl = $('[data-price]', root);
      var stockEl = $('[data-stock]', root);
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '');
      btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (stockEl) { stockEl.textContent = v.available ? '● In stock — ships from supplier warehouse' : '● Sold out'; stockEl.className = 'stock ' + (v.available ? 'stock--in' : 'stock--out'); }
      if (v.featured_image) {
        var main = $('[data-gallery-main]');
        if (main) main.innerHTML = '<img src="' + esc(img(v.featured_image.src, 1000)) + '" alt="' + esc(v.featured_image.alt || product.title) + '" width="1000" height="1000">';
      }
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    }
    root.addEventListener('change', function (e) { if (e.target.closest('.option-group')) update(); });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = d.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  });

  if (drawer) refreshCart().catch(function () {});
  R.openCart = openCart; R.closeCart = closeCart; R.refreshCart = refreshCart;
  window.Ruvio = R;
})();
